import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { Card, CardContent, CardHeader, Box, Tooltip, Typography, ListItem, IconButton, DialogActions, ListItemSecondaryAction, Chip, CircularProgress } from '@mui/material';
import Alert from 'src/components/Alert';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Button from '@mui/material/Button';
import axios from 'src/utils/axios';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import React, { useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import dedupeRows from 'src/utils/dedupeRows';
import 'src/assets/css/confirmOverlay.css';
const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    }),
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    confirmOverlay: {
        zIndex: 9999 + ' !important'
    }
};

// Apollo_GetFiles sadece { id, DOSYA_ADI } dondurur; DOSYA_ADI = "<belge tipi aciklamasi> - <dosya adi>".
// Yuklenen dosyayi belge tipiyle eslestirmek icin elimizdeki tek bilgi bu onek.
const NAME_SEPARATOR = ' - ';

const normalize = (value) => (value === null || value === undefined ? '' : String(value)).trim().toLowerCase();

const belongsToType = (file, aciklama) => {
    if (!aciklama) {
        return false;
    }
    return normalize(file?.DOSYA_ADI).startsWith(normalize(aciklama) + NAME_SEPARATOR);
};

// Listede belge tipi zaten baslik olarak yazdigi icin dosya adindan onegi kaldiriyoruz.
const stripTypePrefix = (file, aciklama) => {
    const fullName = file?.DOSYA_ADI || '';
    if (!aciklama || !belongsToType(file, aciklama)) {
        return fullName;
    }
    return fullName.slice(String(aciklama).trim().length + NAME_SEPARATOR.length) || fullName;
};

function Overview(props) {
    const { basvuruId, documentType, dosyaAdet, documentTypeNumber, openClose } = props;
    const [uyari, setUyari] = React.useState(false);
    const [loading, setLoading] = React.useState(false)
    const [searchName, setSearchName] = React.useState('')
    const [rows, setRows] = React.useState([])
    const [uploadFilePopUp, setUploadFilePopUp] = React.useState(false);
    const [uyariTip, setUyariTip] = React.useState(false);
    const [fileType, setFileType] = React.useState(0);
    const [fileTypeDesc, setFileTypeDesc] = React.useState('');
    const [uyariAciklama, setUyariAciklama] = React.useState('')
    const [selectedFiles, setSelectedFiles] = React.useState([]);
    const [isDragActive, setIsDragActive] = React.useState(false);
    const fileInputRef = React.useRef(null);
    const MAX_FILE_SIZE = 50000000;
    const ACCEPTED_FILE_TYPE = 'application/pdf';



    useEffect(() => {
        if (!basvuruId) {
            return;
        }
        getReceiptFiles(basvuruId);
    }, [props.basvuruId, props.dosyaAdet]);




    const documentTypeList = Array.isArray(documentType) ? documentType : [];
    const visibleDocumentTypes = documentTypeList.filter(i => i.ACIKLAMA?.toLowerCase().includes(searchName.toLowerCase()));
    // Hicbir belge tipiyle eslesmeyen dosyalar (tip aciklamasi degismis/silinmis kayitlar) gizli kalmasin.
    const unmatchedFiles = rows.filter((file) => !documentTypeList.some((row) => belongsToType(file, row.ACIKLAMA)));

    function uploadFiles(filedata) {
        return axios.post("/UploadFile", filedata, {
            headers: { 'Content-Type': 'application/json' }
        });
    }

    const getReceiptFiles = (basvuruId) => {
        if (!basvuruId) {
            setRows([]);
            return Promise.resolve();
        }
        setLoading(true)
        return axios.get("/GetReceiptFiles/" + basvuruId + '/' + 1 + '/' + documentTypeNumber).then(response => {
            setRows(dedupeRows(response.data, 'id'))
            setLoading(false)
        }).catch(() => {
            setLoading(false)
        });
    }

    const handleUserClick = () => {
        getReceiptFiles(basvuruId);
    }


    const setNewWindowOpen = (id) => {
        setLoading(true);
        axios.get("/getReceiptFilesSpecial/" + id).then(response => {
            setLoading(false);
            const res = response.data[0]
            if (!res) {
                return;
            } else {
                var FileData = `data:${res.DOSYA_TIPI};base64,${res.DOSYA_DATA}`
                if (res?.DOSYA_TIPI?.includes('image')) {
                    var image = new Image();
                    image.src = FileData;
                    var w = window.open("");
                    if (!w) {
                        return;
                    }
                    w.document.write(image.outerHTML);
                    w.document.title = res.DOSYA_ADI;
                    w.document.close();
                } else {
                    var blobData = base64ToBlob(res.DOSYA_DATA, "application/pdf");
                    openBlobInNewTab(blobData);
                }
            }
        }).catch(() => {
            setLoading(false);
        });
    }

    function base64ToBlob(base64Data, contentType) {
        var byteCharacters = atob(base64Data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
    function openBlobInNewTab(blobData) {
        var newTab = window.open();
        if (!newTab) {
            return;
        }
        var objectUrl = URL.createObjectURL(blobData);
        newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
    }

    const handleDeleteSureClick = (fileId) => {
        confirmAlert({
            message: ('Silmek istediğinizden emin misiniz?'),
            buttons: [
                {
                    label: ('Evet'),
                    onClick: () => handleDeleteClick(fileId)
                },
                {
                    label: ('Hayır'),
                    onClick: () => { }
                }
            ],
            overlayClassName: "confirmOverlay"
        });
    }

    const handleDeleteClick = (fileId) => {
        setLoading(true);
        axios.get("/DeleteFile/" + fileId, {
            headers: { 'Content-Type': 'application/json' }
        }).then(response => {
            setUyari(true);
            setUyariAciklama("İşleminiz başarı ile gerçekleşti.")
            setUyariTip("success")
            getReceiptFiles(basvuruId)
        }).catch(() => {
            setLoading(false);
            setUyari(true);
            setUyariAciklama("Dosya silinemedi. Lütfen tekrar deneyiniz!...")
            setUyariTip("error")
        });
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };
    const addSelectedFiles = (fileList) => {
        const incoming = Array.from(fileList || []);
        let hasInvalidType = false;
        let hasInvalidSize = false;
        const validFiles = [];
        incoming.forEach((file) => {
            if (file.type !== ACCEPTED_FILE_TYPE) {
                hasInvalidType = true;
                return;
            }
            if (file.size > MAX_FILE_SIZE) {
                hasInvalidSize = true;
                return;
            }
            validFiles.push(file);
        });
        if (hasInvalidType) {
            setUyariAciklama("Sadece pdf dosya yükleyebilirsiniz. Lütfen dosya tipini kontrol ediniz!...");
            setUyari(true);
            setUyariTip("error");
        } else if (hasInvalidSize) {
            setUyariAciklama("Dosya boyutu çok büyük. Lütfen dosya boyutunu kontrol ediniz!...");
            setUyari(true);
            setUyariTip("error");
        }
        if (validFiles.length > 0) {
            setSelectedFiles((prev) => [...prev, ...validFiles]);
        }
    };

    const handleDropFiles = (event) => {
        event.preventDefault();
        setIsDragActive(false);
        addSelectedFiles(event.dataTransfer.files);
    };

    const handleRemoveSelectedFile = (index) => {
        setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    };

    const handleUploadClick = () => {
        if (selectedFiles.length === 0) {
            return;
        }
        const files = selectedFiles.map((file) => ({ file, meta: { name: file.name, type: file.type } }));
        handleSubmitImage(files);
    };

    const handleSubmitImage = async (files) => {
        var selectedDocumentType = documentTypeList.filter(i => i.ID == fileType)[0];
        var fileIsRequired = selectedDocumentType?.ZORUNLU || false;
        if (files.length < props.dosyaAdet && fileIsRequired == 1) {
            setUyariAciklama("Yüklenen dosya adedi, seçilen kişi sayısından büyük ya da eşit olmadılıır. Lütfen kontrol ediniz!...")
            setUyari(true);
            setUyariTip("error");
            return;
        }
        setLoading(true)
        const uploads = [];
        for (let i = 0; i < files.length; i++) {
            const fileMaterial = files[i].file;
            const metaMaterial = files[i].meta;
            let base64ResultMaterial = '';
            if (metaMaterial.type.indexOf('image') !== -1) {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const image = new Image();
                image.src = URL.createObjectURL(fileMaterial);
                await new Promise((resolve, reject) => {
                  image.onload = () => {
                    const maxWidth = 1920;
                    const maxHeight = 1920;
                    let width = image.width;
                    let height = image.height;
                    if (width > maxWidth || height > maxHeight) {
                      if (width / height > maxWidth / maxHeight) {
                        width = maxWidth;
                        height = Math.round(maxWidth * (image.height / image.width));
                      } else {
                        height = maxHeight;
                        width = Math.round(maxHeight * (image.width / image.height));
                      }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(image, 0, 0, width, height);
                    base64ResultMaterial = canvas.toDataURL(metaMaterial.type, 1).split(',')[1];
                    resolve();
                  };
                  image.onerror = reject;
                });
              } else {
                base64ResultMaterial = await base64Reader(fileMaterial);
            }
            const data = {
                FileName: metaMaterial.name,
                FileType: metaMaterial.type,
                ReceiptNumber: basvuruId,
                FileData: base64ResultMaterial,
                TypeId: fileType,
                OnOnay: 1,
                OpenClose: openClose
            }
            uploads.push(uploadFiles(data));
        }
        try {
            await Promise.all(uploads);
        } catch (error) {
            setLoading(false);
            setUploadFilePopUp(false);
            setUyariAciklama("Dosya yüklenemedi. Lütfen tekrar deneyiniz!...");
            setUyari(true);
            setUyariTip("error");
            return;
        }
        setSelectedFiles([]);
        setUploadFilePopUp(false);
        setUyariAciklama(files.length > 1
            ? `${files.length} dosya başarıyla yüklendi.`
            : "İşleminiz başarı ile gerçekleşti.");
        setUyari(true);
        setUyariTip("success");
        await getReceiptFiles(basvuruId);
    };



    async function base64Reader(file) {
        const result_base64 = await new Promise(resolve => {
            const fileReader = new FileReader();
            fileReader.onload = e => resolve(fileReader.result);
            fileReader.readAsDataURL(file);
        });
        return result_base64.split(',')[1] || '';
    }

    const renderFileRow = (file, primaryText) => (
        <ListItem key={file.id} disablePadding>
            <ListItemText
                primary={primaryText}
                slotProps={{ primary: { sx: { pr: 9, wordBreak: 'break-word' } } }}
            />
            <ListItemSecondaryAction>
                <Tooltip title="Göster">
                    <IconButton size="small" onClick={() => setNewWindowOpen(file.id)}>
                        <VisibilityIcon color='primary' fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Sil">
                    <IconButton size="small" onClick={() => handleDeleteSureClick(file.id)}>
                        <DeleteIcon color='primary' fontSize="small" />
                    </IconButton>
                </Tooltip>
            </ListItemSecondaryAction>
        </ListItem>
    );

    return (
        <>
            <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={uyariKapat} variant={uyariTip} message={uyariAciklama}>
                </Alert>
            </Snackbar>
            <Card>
                <CardHeader title="Belge Yükle" />
                <CardContent>
                    <TextField
                        id="standard-basic"
                        label="Ara"
                        value={searchName}
                        onChange={(event) => setSearchName(event.target.value)}
                        fullWidth
                        size="small"
                        sx={{ mb: 2 }}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                        {visibleDocumentTypes.map((row, index) => {
                                const filesForType = rows.filter((f) => belongsToType(f, row.ACIKLAMA));
                                const isRequired = row.ZORUNLU === 1;
                                const uploadedCount = filesForType.length;
                                const isSatisfied = uploadedCount > 0;
                                return (
                                    <Box
                                        key={index}
                                        sx={{
                                            border: '1px solid',
                                            borderColor: isSatisfied ? 'success.light' : '#e0e0e0',
                                            backgroundColor: isSatisfied ? 'rgba(76,175,80,0.04)' : 'transparent',
                                            borderRadius: 2,
                                            p: 1.5
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            {isSatisfied ? (
                                                <CheckCircleIcon color="success" />
                                            ) : isRequired ? (
                                                <ErrorOutlineIcon color="error" />
                                            ) : (
                                                <RadioButtonUncheckedIcon color="disabled" />
                                            )}
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography sx={{ fontWeight: 600 }}>
                                                    {row.ACIKLAMA} <span style={{ color: 'red' }}> (*pdf)</span>
                                                </Typography>
                                                <Box sx={{ display: 'flex', gap: 0.75, mt: 0.5, flexWrap: 'wrap' }}>
                                                    <Chip
                                                        size="small"
                                                        label={isRequired ? 'Zorunlu' : 'Opsiyonel'}
                                                        color={isRequired ? 'error' : 'default'}
                                                        variant="outlined"
                                                    />
                                                    <Chip
                                                        size="small"
                                                        label={uploadedCount > 0 ? `${uploadedCount} dosya yüklendi` : 'Eksik'}
                                                        color={uploadedCount > 0 ? 'success' : (isRequired ? 'error' : 'default')}
                                                    />
                                                </Box>
                                            </Box>
                                            <Tooltip title="Dosya Yükle">
                                                <IconButton
                                                    edge="end"
                                                    onClick={() => {
                                                        setUploadFilePopUp(true)
                                                        setFileType(row.ID)
                                                        setFileTypeDesc(row.ACIKLAMA)
                                                        setSelectedFiles([]);
                                                        handleUserClick()
                                                    }}>
                                                    <AttachFileOutlinedIcon color="primary" />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        {filesForType.length > 0 && (
                                            <List dense sx={{ mt: 1 }}>
                                                {filesForType.map((file) => renderFileRow(file, stripTypePrefix(file, row.ACIKLAMA)))}
                                            </List>
                                        )}
                                    </Box>
                                );
                            })}
                        {!loading && documentTypeList.length === 0 && (
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                Bu adım için tanımlı belge tipi bulunmamaktadır.
                            </Typography>
                        )}
                        {unmatchedFiles.length > 0 && (
                            <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 2, p: 1.5 }}>
                                <Typography sx={{ fontWeight: 600 }}>Diğer Yüklenen Belgeler</Typography>
                                <List dense sx={{ mt: 1 }}>
                                    {unmatchedFiles.map((file) => renderFileRow(file, file.DOSYA_ADI))}
                                </List>
                            </Box>
                        )}
                        {loading && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <CircularProgress size={18} />
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    Belgeler güncelleniyor...
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </CardContent>
            </Card>
            <Dialog
                open={uploadFilePopUp}
                onClose={() => { setUploadFilePopUp(false); setSelectedFiles([]); }}
                aria-describedby="alert-dialog-slide-description"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ width: '100%' }} >{fileTypeDesc ? `Dosya Yükle - ${fileTypeDesc}` : 'Dosya Yükle'}</DialogTitle>
                <DialogContent sx={{ pt: 2.5 }}>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="application/pdf"
                        multiple
                        hidden
                        onChange={(event) => {
                            addSelectedFiles(event.target.files);
                            event.target.value = '';
                        }}
                    />
                    <Box
                        onClick={() => fileInputRef.current?.click()}
                        onDragOver={(event) => { event.preventDefault(); setIsDragActive(true); }}
                        onDragLeave={() => setIsDragActive(false)}
                        onDrop={handleDropFiles}
                        sx={{
                            minHeight: 200,
                            maxHeight: 250,
                            border: '2px dashed',
                            borderColor: isDragActive ? '#FF9800' : '#bdbdbd',
                            borderRadius: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            backgroundColor: isDragActive ? 'rgba(255,152,0,0.05)' : 'transparent',
                            transition: 'all 0.2s ease',
                            p: 2
                        }}
                    >
                        <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
                            {selectedFiles.length > 0
                                ? `${selectedFiles.length} dosya seçildi. Eklemek için tıklayın.`
                                : 'Dosyayı sürükleyip bırakın ya da tıklayın'}
                        </Typography>
                    </Box>
                    {selectedFiles.length > 0 && (
                        <List dense sx={{ mt: 1 }}>
                            {selectedFiles.map((file, index) => (
                                <ListItem key={index} disablePadding>
                                    <ListItemText primary={file.name} />
                                    <ListItemSecondaryAction>
                                        <IconButton size="small" onClick={() => handleRemoveSelectedFile(index)}>
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>
                    )}
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        sx={{ mt: 2 }}
                        disabled={selectedFiles.length === 0 || loading}
                        onClick={handleUploadClick}
                    >
                        Yükle
                    </Button>
                </DialogContent>
                <DialogActions>
                    <DialogActions>
                        <IconButton
                            color="primary"
                            onClick={() => { setUploadFilePopUp(false); setSelectedFiles([]); }}
                            aria-label="close"
                            component="span"
                            variant="contained"
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogActions>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default Overview;
